<template>
  <div class="login-page">
    <div class="login-box">
      <h1>登录</h1>
      <p>请输入账号密码登录</p>

      <form @submit.prevent="handleLogin">
        <input
          v-model="form.Account"
          type="text"
          placeholder="账号"
          autocomplete="username"
        />
        <input
          v-model="form.Password"
          type="password"
          placeholder="密码"
          autocomplete="current-password"
        />
        <button type="submit" :disabled="loading">
          {{ loading ? "登录中..." : "登录" }}
        </button>
        <div class="changePassword" @click="changeClick">修改密码？</div>
      </form>
    </div>
    <a-drawer
      title="修改密码"
      :width="720"
      :visible="visible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <a-form :model="formChange" :rules="rules" layout="vertical">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="账号" name="Account">
              <a-input v-model:value="formChange.Account" placeholder="请输入账号" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="旧密码" name="OldPassword">
              <a-input
                v-model:value="formChange.OldPassword"
                type="password"
                placeholder="请输入旧密码"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="新密码" name="NewPassword">
              <a-input
                v-model:value="formChange.NewPassword"
                type="password"
                placeholder="请输入新密码"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button style="margin-right: 8px" @click="onClose">Cancel</a-button>
        <a-button type="primary" @click="SubmitClick">Submit</a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { message } from "ant-design-vue";
// import router from "../router";
import { useRouter } from "vue-router";
import axios from "axios";

const router = useRouter();

const visible = ref(false);

const onClose = () => {
  visible.value = false;
};

const SubmitClick = () => {
  axios
    .post("https://camapi.bodor.com:8088/api/OT/ChangePassword", formChange)
    .then((response) => {
      visible.value = false;
      if (response.data.code == 200 && response.data.ReturnType) {
        message.success("修改成功");
      } else {
        message.error(response.data.info);
      }
    })
    .catch((err) => {
      visible.value = false;
    });
};

const changeClick = () => {
  visible.value = true;
};

const form = reactive({
  Account: "",
  Password: "",
});

const formChange = reactive({
  Account: "",
  OldPassword: "",
  NewPassword: "",
});
const rules = {
  Account: [
    {
      required: true,
      message: "请输入账号",
    },
  ],
  OldPassword: [
    {
      required: true,
      message: "请输入账号",
    },
  ],
  NewPassword: [
    {
      required: true,
      message: "请输入账号",
    },
  ],
};

const loading = ref(false);

const handleLogin = () => {
  if (!form.Account || !form.Password) return;
  loading.value = true;
  // setTimeout(() => {
  //   loading.value = false
  //   console.log('login', form)
  //   localStorage.setItem('token','123');
  //   router.replace({
  //     path:'/largescreen'
  //   })
  // }, 1000)
  // axios.post("")
  axios
    .post("https://camapi.bodor.com:8088/api/OT/OTCheckLogin", form)
    .then((response) => {
      if (response.data.code == 200 && response.data.ReturnType) {
        localStorage.setItem("token", response.data.ReturnData.token);
        localStorage.setItem("kpiUserId", response.data.ReturnData.Id);
        message.success("登录成功");
        router.push("/WorkKpiDef");
      } else {
        loading.value = false;
        message.error(response.data.info);
      }
    })
    .catch((err) => {
      loading.value = false;
      console.log("错误信息:", err.message);
      console.log("服务器响应:", err.response);
      console.log("响应数据:", err.response?.data);
      console.log("响应状态:", err.response?.status);
      console.log("完整错误对象:", err);
    });
};
</script>

<style scoped lang="scss">
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.login-box {
  width: 500px;
  padding: 48px 40px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  .changePassword {
    text-align: right;
    cursor: pointer;
  }
  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 8px;
  }

  p {
    font-size: 14px;
    color: #999;
    margin: 0 0 32px;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  input {
    height: 48px;
    padding: 0 16px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    font-size: 15px;
    color: #333;
    background: #fafafa;
    outline: none;
    transition: all 0.2s;

    &::placeholder {
      color: #bbb;
    }

    &:focus {
      border-color: #333;
      background: #fff;
    }
  }

  button {
    height: 48px;
    margin-top: 8px;
    border: none;
    border-radius: 8px;
    background: #1a1a1a;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #333;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>
